import {
  AlertCircleIcon,
  AnalyticsUpIcon,
  CheckmarkCircle01Icon,
  IdeaIcon,
} from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { createFileRoute } from '@tanstack/react-router';
import { Badge } from '@/components/ui/badge';
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export const Route = createFileRoute('/_authenticated/analytics/insights')({
  component: AnalyticsInsights,
});

const insights = [
  {
    id: 1,
    title: 'Peak Traffic Hours',
    description: 'Your website receives 60% more traffic between 2-4 PM EST',
    type: 'opportunity',
    impact: 'High',
    icon: AnalyticsUpIcon,
  },
  {
    id: 2,
    title: 'Mobile Optimization Needed',
    description: 'Mobile bounce rate is 15% higher than desktop',
    type: 'warning',
    impact: 'Medium',
    icon: AlertCircleIcon,
  },
  {
    id: 3,
    title: 'Conversion Funnel Improvement',
    description: 'Checkout completion rate increased by 12% this month',
    type: 'success',
    impact: 'High',
    icon: CheckmarkCircle01Icon,
  },
  {
    id: 4,
    title: 'Content Performance',
    description: 'Blog posts generate 3x more engagement than product pages',
    type: 'insight',
    impact: 'Medium',
    icon: IdeaIcon,
  },
];

const typeColors = {
  opportunity: 'bg-blue-500',
  warning: 'bg-yellow-500',
  success: 'bg-green-500',
  insight: 'bg-purple-500',
};

function AnalyticsInsights() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Insights</h1>
        <p className="text-muted-foreground">AI-powered recommendations and observations</p>
      </div>

      <div className="grid gap-4">
        {insights.map((insight) => (
          <Card key={insight.id}>
            <CardHeader>
              <div className="flex items-start gap-4">
                <div
                  className={`h-10 w-10 rounded-lg ${typeColors[insight.type as keyof typeof typeColors]} flex items-center justify-center flex-shrink-0`}
                >
                  <HugeiconsIcon icon={insight.icon} className="h-5 w-5 text-white" />
                </div>
                <div className="flex-1 space-y-1">
                  <div className="flex items-center justify-between">
                    <CardTitle>{insight.title}</CardTitle>
                    <Badge variant={insight.impact === 'High' ? 'default' : 'secondary'}>
                      {insight.impact} Impact
                    </Badge>
                  </div>
                  <CardDescription>{insight.description}</CardDescription>
                </div>
              </div>
            </CardHeader>
          </Card>
        ))}
      </div>
    </div>
  );
}
